export type FormatTypeformLinkParams = {
  link: string;
  email?: string;
  firstName?: string;
  lastName?: string;
  eventId?: string;
  locationId?: string;
};

export const formatTypeformLink = ({ link, email, firstName, lastName, eventId, locationId }: FormatTypeformLinkParams): string => {
  // Special case for concierge link to append event data as hash params
  const url = new URL(link);

  // Build hash with actual data - only include non-empty params
  const params = [
    { key: 'email', value: email || '' },
    { key: 'first_name', value: firstName || '' },
    { key: 'last_name', value: lastName || '' },
    { key: 'eventid', value: eventId || '' },
    { key: 'location', value: locationId || '' },
  ]
    .filter(param => param.value && param.value.trim() !== '')
    .map(param => `${param.key}=${encodeURIComponent(param.value)}`)
    .join('&');

  url.hash = params ? `#${params}` : '';
  return url.toString();
};
